<template>
  <div class="container mt-4">
    <loading loader="bars" :active.sync="isLoading"></loading>
    <div class="input-group w-75 mx-auto searchBox row">
      <div class="col-12 col-sm-3 p-0 mb-2 mb-sm-0">
        <input
          class="form-control form-control-lg city"
          type="search"
          placeholder="城市"
          @change="searchBtn"
          v-model="search.city"
        />
      </div>
      <div class="col-12 col-sm-3 p-0 mb-2 mb-sm-0">
        <input
          class="form-control form-control-lg area"
          type="search"
          placeholder="地區"
          @change="searchBtn"
          v-model="search.area"
        />
      </div>
      <div class="col-12 col-sm-4 p-0 mb-2 mb-sm-0">
        <input
          class="form-control form-control-lg keyWord"
          type="search"
          placeholder="關鍵字"
          @change="searchBtn"
          v-model="search.keyWord"
        />
      </div>
      <div class="col-12 col-sm-2 p-0 mb-2 mb-sm-0">
        <div class="input-group-append">
          <button
            class="btn btn-outline-secondary btn-lg btn-block searchBtn"
            type="button"
            @click="searchBtn"
          >搜尋</button>
        </div>
      </div>
    </div>
    <div class="container mt-4">
      <div class="row">
        <div class="font-weight-bold mx-auto h4 mt-5 brown" v-show="list.length<=0">
          <div
            class="spinner-grow text-secondary"
            style="width: 3rem; height: 3rem;"
            role="status"
            v-if="status.upLoading"
          >
            <span class="sr-only">Loading...</span>
          </div>
          <p v-if="!status.upLoading">
            <i class="las la-frown"></i>沒有符合的店家喔~
          </p>
        </div>
        <div
          v-show="list.length>0"
          class="col-sm-4 col-lg-3 mb-3"
          v-for="(item, index) in list"
          :key="index"
          @mouseleave="show(item)"
          @mouseenter="show(item)"
        >
          <router-link :to="{ name: 'Store', params: { BusinessId: item.Id }}">
            <div class="card bg-navy text-white">
              <img :src="item.PictureAddress1" class="card-img" alt="..." />
              <div
                class="card-img-overlay d-flex flex-column justify-content-center align-items-center"
              >
                <h5
                  class="card-title font-weight-bold"
                  v-show="item.active"
                  :class="{'text':item.active}"
                >{{ item.BusinessName }}</h5>
                <p
                  class="card-text font-weight-bold"
                  v-show="item.active"
                  :class="{'text':item.active}"
                >{{ item.City }}</p>
              </div>
              <div class="mask" :class="{'mask-hover':item.active}"></div>
            </div>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      list: [],
      search: {
        city: '',
        area: '',
        keyWord: ''
      },
      isLoading: false,
      status: {
        upLoading: false
      }
    }
  },
  methods: {
    show (item) {
      item.active = !item.active
    },
    searchBtn () {
      this.status.upLoading = true
      const vm = this
      const url = 'http://imrebooksystem.rocket-coding.com/CustomerUsers/SearchBusiness'
      this.axios
        .get(url, {
          params: {
            city: vm.search.city,
            area: vm.search.area,
            keyWord: vm.search.keyWord
          }
        })
        .then(function (res) {
          res.data.forEach(element => {
            element.active = false
          })
          vm.list = res.data
          vm.status.upLoading = false
        })
        .catch(error => console.error(error))
    }
  },
  created () {
    this.isLoading = true
    const vm = this
    const url = 'http://imrebooksystem.rocket-coding.com/BusinessUsers/GetBusinessList'
    this.axios
      .get(url)
      .then(function (res) {
        res.data.forEach(element => {
          element.active = false
        })
        vm.list = res.data
        vm.isLoading = false
      })
      .catch(error => console.error(error))
  }
}
</script>

<style lang="scss" scoped>
.searchBox {
  input {
    background-color: transparent;
    color: #b8817d !important;
  }
  input:focus {
    background-color: transparent;
  }
  .city {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
  .area,
  .keyWord {
    border-radius: 0;
  }
  .searchBtn {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
}
.card {
  border: 0;
  max-width: 260px;
  max-height: 260px;
  min-width: 260px;
  min-height: 260px;
  overflow: hidden;
  img {
    margin: auto;
  }
}
.mask {
  position: absolute;
  height: 100%;
  width: 100%;
  transition: 1s;
}
.mask-hover {
  background-color: rgba(184, 129, 125, 0.596);
  transition: 1s;
}
.text {
  z-index: 2;
}
@media (max-width: 1200px) {
  .card {
    max-width: 220px;
    max-height: 220px;
    min-width: 220px;
    min-height: 220px;
  }
}
@media (max-width: 992px) {
  .card {
    max-width: 220px;
    max-height: 220px;
    min-width: 220px;
    min-height: 220px;
  }
}
@media (max-width: 768px) {
  .card {
    max-width: 200px;
    max-height: 200px;
    min-width: 200px;
    min-height: 200px;
  }
}
@media (max-width: 576px) {
  .city,
  .area,
  .keyWord,
  .searchBtn {
    padding: 0.25rem 0.5rem;
    font-size: 0.875rem;
    line-height: 1.5;
    border-radius: 0.2rem !important;
  }
  .card {
    max-width: 300px;
    max-height: 300px;
    min-width: 300px;
    min-height: 300px;
    margin: auto;
  }
}
</style>
